module.exports = __webpack_public_path__ + "img/san-pro-care.a5b4665.png";